export default function Footer() {
    return (
        <footer className="bg-white border-t mt-auto">
          <div className="max-w-7xl mx-auto px-4 py-4 text-center text-sm text-gray-600">
            © {new Date().getFullYear()} ACA Landscape. All rights reserved.
          </div>
        </footer>
    )
}